<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="150px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <!-- <el-form-item label="上级组织" prop="pid">
        <el-cascader v-model="form_data.pid" :options="tree_node" :props="{ checkStrictly: true }" clearable></el-cascader>
      </el-form-item> -->
      <el-form-item label="组织类型" prop="type_id" v-if="!hasId">
        <el-radio-group v-model="form_data.type_id">
          <el-radio :label="1">管理层级</el-radio>
          <el-radio :label="2">职能部门</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="上级组织架构" prop="org_id">
        <el-cascader v-model="form_data.pid" :options="org_tree_node" :props="{ checkStrictly: true }" clearable :disabled="hasId"></el-cascader>
      </el-form-item>
      <el-form-item label="组织名称" prop="org_name">
        <el-input v-model="form_data.org_name" autocomplete="off" placeholder="请输入组织名称"></el-input>
      </el-form-item>
      <el-form-item label="组织简称" prop="org_short_name">
        <el-input v-model="form_data.org_short_name" autocomplete="off" placeholder="请输入组织简称"></el-input>
      </el-form-item>

      <el-form-item label="缩写" prop="org_abbreviation">
        <el-input v-model="form_data.org_abbreviation" autocomplete="off" placeholder="请输入缩写"></el-input>
      </el-form-item>

<!--      <el-form-item label="管理街道" prop="street_ids" v-if="form_data.type == 1">
        <el-select v-model="form_data.street_ids" multiple placeholder="请选择街道(可多选)" clearable @change="changes" :disabled="street_list.length==0 ">
          <el-option v-for="item in street_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="管理社区" prop="community_ids" v-if="form_data.type == 1">
        <el-select v-model="form_data.community_ids" placeholder="请选择社区(可多选)" multiple :disabled="community_list.length==0  ">
          <el-option v-for="item in community_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="管理模块类型" prop="moduler_ids">
        <el-select v-model="form_data.moduler_ids" multiple placeholder="请选择模块类型(可多选)">
          <el-option v-for="item in moduler_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "l-applet-org-edit",
  props: {
    id: {
      type: [Number, String],
      default: null,
    },

    pid: {
      type: [Number, String],
      default: "",
    },
    visible: {
      type: Boolean,
    },
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  data() {
    return {
      loading: false,
      org_tree_node: [],
      moduler_list: [],
      street_list:[],
      community_list:[],
      place_type_list:[],
      //表单数据
      submitting: false,
      form_data: {
        pid: 1,
        org_name: "",
        type_id: 2,
        company_type: 2,
        code: "",
        moduler_ids: [],
        is_force_hall: 0,
        is_force_dev_code: 0,
        street_ids: [],
        community_ids:[],
        place_type_list:[],
      },

      p_info: {},

      rules: {
        pid: [
          {
            type: "number",
            required: true,
            message: "请选择上级组织",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "number",
            required: true,
            message: "请选择组织类型",
            trigger: "change",
          },
        ],
        name: [
          { required: true, message: "请输入组织名称", trigger: "change" },
        ],
        short_name: [
          { required: true, message: "请输入简称", trigger: "change" },
        ],
      },
    };
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          // console.log(this.$props.pid);
          this.getData();
        }
      },
    },
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },
    //点击获取社区
  // changes() {
  //     this.$_invoke("uniOrg_getAddData", {
  //       street_ids: this.form_data.street_ids
  //     })  .then((ret) => {
           
  //           this.community_list = ret.community_list;
  //         })
  //         .finally(() => {
  //           this.loading = false;
  //         });
  //   },

    //获取添加数据
    getData() {

      if (this.hasId) {
        this.loading = true;
        //编辑获取数据
        this.$_invoke("uniOrg_getEditData", { id: this.$props.id })
            .then((ret) => {
            let {data, org_tree_node, moduler_list} = ret;
            this.org_tree_node = org_tree_node;
            this.moduler_list = moduler_list;
            this.form_data = data;
          //   this.$nextTick(() => {
          //     if (!is_company) {
          //       //找到pid所属的路径
          //       const curr_p_data = list.find((item) => {
          //         return item.id == data.pid;
          //       });

          //       // console.log(curr_p_data);
          //       let p_path_arr = curr_p_data.path.split(">");
          //       p_path_arr = p_path_arr.filter((item) => {
          //         return item != "";
          //       });
          //       p_path_arr.push(data.pid);
          //       p_path_arr = p_path_arr.map((item) => {
          //         return parseInt(item);
          //       });
          //       p_path_arr.splice(0, 1);
          //       data.pid = p_path_arr;
          //     } else {
          //       data.pid = [data.pid];
          //     }

          //     this.form_data = data;
          //   });
          })
          .finally(() => {
            this.loading = false;
          });
      }else {
        this.$_invoke("uniOrg_getAddData", {
            pid: this.$props.pid
        })
          .then((ret) => {
            // console.log(ret)
            this.form_data = ret.data;
            this.org_tree_node = ret.org_tree_node;
            this.moduler_list = ret.moduler_list;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          this.form_data.pid = this.$props.pid;
          if (!this.hasId) {
            //添加
            this.$_invoke("uniOrg_save", this.form_data)
              .then(() => {
                this.$_msg.success("添加成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          } else {
            //修改
            this.$_invoke(`uniOrg_update`, this.form_data)
              .then(() => {
                this.$_msg.success("修改成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          }
        }
      });
    },
  },
};
</script>
